import * as React from "react";

export default (props:any) => (
    <svg
        width={32}
        height={32}
        viewBox="0 0 24 24"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"></path>
    </svg>
);

